import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search, RotateCcw, Users, Sparkles } from "lucide-react";
import { langNL, countryNL } from "@/config/languageLabels";

const ANY = "__any";

export default function VoiceFilters({ filters, values, onChange, onReset, hideTypeToggle }) {
  const set = (k) => (v) => onChange({ ...values, [k]: v === ANY ? "" : v });
  const ageOptions = ["6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"];

  return (
    <div className="rounded-2xl border border-zinc-200 bg-white p-4 md:p-5">
      <div className="flex flex-col gap-3">
        <div className="relative">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
          <Input data-testid="voice-search-input" placeholder="Zoek stemmen op naam…"
            value={values.q || ""} onChange={(e) => onChange({ ...values, q: e.target.value })}
            className="pl-10 rounded-xl h-11" />
        </div>

        {!hideTypeToggle && (
        <div className="flex rounded-full bg-zinc-100 p-1 text-sm font-semibold">
          {[["", "Alle", null, "all"], ["human", "Mens", Users, "human"], ["ai", "AI", Sparkles, "ai"]].map(([val, label, Icon, tid]) => (
            <button key={label} data-testid={`filter-type-${tid}`}
              onClick={() => onChange({ ...values, voice_type: val })}
              className={`flex flex-1 items-center justify-center gap-1.5 rounded-full py-2 transition ${
                (values.voice_type || "") === val ? "bg-white text-brand-violet shadow-sm" : "text-zinc-500"}`}>
              {Icon && <Icon size={14} />} {label}
            </button>
          ))}
        </div>
        )}

        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          <FilterSelect testid="filter-language" label="Taal" value={values.language}
            onChange={set("language")} options={filters.languages || []} format={langNL} />
          <FilterSelect testid="filter-country" label="Land" value={values.country}
            onChange={set("country")} options={filters.countries || []} format={countryNL} />
          <div>
            <label className="label-eyebrow text-zinc-400 mb-1 block">Geslacht</label>
            <Select value={values.gender || ANY} onValueChange={set("gender")}>
              <SelectTrigger data-testid="filter-gender" className="rounded-xl h-11"><SelectValue placeholder="Alle" /></SelectTrigger>
              <SelectContent>
                <SelectItem value={ANY}>Alle</SelectItem>
                <SelectItem value="male">Jongen</SelectItem>
                <SelectItem value="female">Meisje</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="label-eyebrow text-zinc-400 mb-1 block">Stemleeftijd</label>
            <Select value={values.age || ANY} onValueChange={set("age")}>
              <SelectTrigger data-testid="filter-age" className="rounded-xl h-11"><SelectValue placeholder="Alle" /></SelectTrigger>
              <SelectContent>
                <SelectItem value={ANY}>Alle</SelectItem>
                {ageOptions.map((a) => <SelectItem key={a} value={a}>{a} jaar</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>

        <button onClick={onReset} data-testid="reset-filters"
          className="mt-1 inline-flex items-center gap-2 self-start text-sm font-semibold text-zinc-500 hover:text-brand-violet">
          <RotateCcw size={14} /> Filters wissen
        </button>
      </div>
    </div>
  );
}

function FilterSelect({ testid, label, value, onChange, options, format }) {
  const fmt = format || ((x) => x);
  return (
    <div>
      <label className="label-eyebrow text-zinc-400 mb-1 block">{label}</label>
      <Select value={value || ANY} onValueChange={onChange}>
        <SelectTrigger data-testid={testid} className="rounded-xl h-11"><SelectValue placeholder="Alle">{value ? fmt(value) : "Alle"}</SelectValue></SelectTrigger>
        <SelectContent>
          <SelectItem value={ANY}>Alle</SelectItem>
          {options.map((o) => <SelectItem key={o} value={o}>{fmt(o)}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
